import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { StudentProfile } from '../../../core/services/student-portal.service';
import { ApplicantFieldsFormValue } from '../models/applicant-fields.model';

export const ApplicantFieldsActions = createActionGroup({
  source: 'Applicant Fields',
  events: {
    'Load Page Data': emptyProps(),
    'Load Page Data Success': props<{
      profile: StudentProfile | null;
      savedFields: Partial<ApplicantFieldsFormValue>;
    }>(),
    'Load Page Data Failure': props<{ savedFields: Partial<ApplicantFieldsFormValue> }>(),
    'Save Fields': props<{ value: ApplicantFieldsFormValue }>(),
    'Save Fields Success': props<{ value: ApplicantFieldsFormValue }>(),
    'Save Fields Failure': props<{ error: string }>(),
  },
});
